import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducer';
import Button from 'seedly-component-library/button-new';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { followGroupsRequest } from 'entity/group/groupRedux';
import {
  closeJoinGroupModal,
  openSignUpCompleteModal,
} from 'dispatcher/modalDispatcher';

const JoinGroupModalFooter = ({
  selectedGroupIds,
}: {
  selectedGroupIds: number[];
}) => {
  const footerText = 'Create My Feed';
  const dispatch = useDispatch();

  const isUserSigningUp = useSelector(
    (props: RootState) => props.modal.joinGroupModalMeta.isSigningUp,
  );

  return (
    <div className="p-4 lg:pb-0">
      <div className="flex flex-col w-full items-center">
        <Button
          onClick={() => {
            dispatch(closeJoinGroupModal({ isSigningUp: false }));
            dispatch(followGroupsRequest(selectedGroupIds));

            if (isUserSigningUp) {
              mixpanel.track(trackedEvents.LoginSignUpModal, {
                param: 'joined_group',
              });
              dispatch(openSignUpCompleteModal());
            }
          }}
          size="sm"
          isBlock
          disabled={selectedGroupIds.length < 3}
        >
          {selectedGroupIds.length < 3
            ? 'Join 3 or more to continue'
            : footerText}
        </Button>
      </div>
    </div>
  );
};

export default JoinGroupModalFooter;
